import { useState, useEffect, Fragment } from "react";

import GlobalStyle from "./globalStyle";
import "./styles.css";

import SoloLoop from "./containers/SoloLoop";
import CompareTypesGrid from "./containers/CompareTypesGrid";
import Manual from "./containers/Manual/Manual";
import ModeSelector from "./containers/ModeSelector";
import TypeExplorer from "./containers/TypeExplorer";
import TypeComparison from "./containers/TypeComparison";
import { personTypesData } from "./data/personTypesData";
import { round2Dec } from "./utils/helpers";
import { modesData } from "./utils/globalConst";

export default function App() {
  const [counter, setCounter] = useState(0);
  const [mode, setMode] = useState(modesData[0].title);
  const loopTime = 1000;

  const personTypesArray = personTypesData.map((d) => d.type);

  const min = 0.01;
  const max = 0.99;
  const [xvn, setXvn] = useState(round2Dec(max * 0.35));
  const [ns, setNs] = useState(round2Dec(max * 0.54));
  const [tf, setTf] = useState(round2Dec(max * 0.75));
  const paramStates = [
    { ns, setNs },
    { tf, setTf },
    { xvn, setXvn },
  ];

  const useMbtiLetters = () => {
    const [letters, setLetters] = useState({
      ieLetter: "E",
      nsLetter: "S",
      tfLetter: "F",
      pjLetter: "J",
    });

    return [letters, setLetters];
  };

  const mbti1Obj = useMbtiLetters();
  const mbti2Obj = useMbtiLetters();

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter((c) => (c <= personTypesArray.length - 2 ? c + 1 : 0));
    }, loopTime);

    return () => clearInterval(timer);
  });

  return (
    <Fragment>
      <GlobalStyle />
      <div className="App">
        {mode === "Cognitive Function Explorer" && (
          <TypeExplorer {...{ paramStates, min, max, mbti1Obj }} />
        )}
        {mode === "Type Comparison" && (
          <TypeComparison {...{ paramStates, min, max, mbti1Obj, mbti2Obj }} />
        )}
        <ModeSelector {...{ mode, setMode }} />
        <Manual />
        {/* <SoloLoop {...{ personTypesArray, counter }} /> */}
      </div>
    </Fragment>
  );
}
